module.exports = __webpack_public_path__ + "539a5e2f316d3a8c81ad982ce70f59da.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/colossal_clashes-320.webp
// module id = 224
// module chunks = 0